export const KEYCLOAK_ISSUER = 'https://auth.sh.calo.app/realms/hub';

export type KeycloakAccount = { kitchens: string[]; permissions: string[]; name: string };
export type KeycloakCaller = { sub: string; account: KeycloakAccount };

export const isClaimRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null && !Array.isArray(value);

const strings = (value: unknown): string[] =>
  Array.isArray(value) ? value.filter((entry): entry is string => typeof entry === 'string') : [];

// The person's name, else email, else phone: an audit label, shown to head chefs only as the account label.
const displayName = (claims: Record<string, unknown>): string =>
  strings([claims.name, claims.email, claims.phone_number]).find((value) => value !== '') ?? '';

// Claims are trusted only after AppSync verifies the JWT; browser parsing is for display, not authorization.
export const keycloakCaller = (claims: unknown): KeycloakCaller | undefined => {
  if (
    !isClaimRecord(claims) ||
    claims.iss !== KEYCLOAK_ISSUER ||
    claims.typ !== 'Bearer' ||
    claims.azp !== 'kds' ||
    (claims.aud !== 'kds' && !strings(claims.aud).includes('kds')) ||
    typeof claims.sub !== 'string' ||
    !claims.sub
  ) {
    return undefined;
  }
  return {
    sub: `keycloak:hub:${claims.sub}`,
    account: {
      permissions: strings(claims.kds_permissions)
        .filter((role) => role.startsWith('kds:'))
        .map((role) => role.slice(4)),
      kitchens: strings(claims.kitchen),
      name: displayName(claims)
    }
  };
};
